import {
  call, put, select, debounce, cancel, takeEvery,
} from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import { showErrorNotification } from 'store/shared/actions';
import { resetUpdatedItems } from 'store/items/actions';
import { getBrowseItems as getBrowseItemsAction, setBrowseItemsFilters } from 'store/browse-items/actions';
import { getBrowseItemsFilters, getBrowseItemsFormattedFilters } from 'store/browse-items/selectors';
import { FILTER_KEYS } from 'store/browse-items/fixtures';
import * as constants from './constants';
import * as actions from './actions';

export function* getBrowseItems() {
  try {
    const {
      [FILTER_KEYS.HAS_MORE]: hasMore,
      [FILTER_KEYS.PAGE]: page,
      [FILTER_KEYS.TYPE]: type,
      [FILTER_KEYS.QUANTITY]: qty,
      ...query
    } = yield select(getBrowseItemsFormattedFilters);
    const filters = yield select(getBrowseItemsFilters);
    const currentPage = hasMore ? page + 1 : 1;

    const params = {
      query: {
        ...query,
        ...(qty === null ? {} : { [FILTER_KEYS.QUANTITY]: qty }),
        [FILTER_KEYS.SORT_DIRECTION]: type === 'set' && filters[FILTER_KEYS.SORT_DIRECTION] === 'itemName' ? 'setName' : filters[FILTER_KEYS.SORT_DIRECTION],
        [FILTER_KEYS.PAGE]: currentPage,
        isV2: true,
      },
    };

    if(currentPage === 1) {
      resetUpdatedItems();
    }

    const api = type === 'item' ? API.BROWSE_ITEMS : API.BROWSE_SETS;

    const { data } = yield call(request, api, 'GET', params);

    yield put(actions.getBrowseItemsSuccess({
      data,
      filters: {
        ...params.query,
        [FILTER_KEYS.HAS_MORE]: data.length > 0 && query[FILTER_KEYS.PER_PAGE] === data.length,
        [FILTER_KEYS.TYPE]: type,
        [FILTER_KEYS.QUANTITY]: qty,
        [FILTER_KEYS.TAGS]: filters[FILTER_KEYS.TAGS],
        [FILTER_KEYS.ITEMS]: filters[FILTER_KEYS.ITEMS],
        [FILTER_KEYS.COLORS]: filters[FILTER_KEYS.COLORS],
        [FILTER_KEYS.QUERY]: filters[FILTER_KEYS.QUERY],
      },
    }));
  } catch (e) {
    yield put(actions.getBrowseItemsError(e));
    yield put(showErrorNotification({ message: 'Failed to fetch data, please try later.' }));
  }
}

export function* getBrowseItemsWatcher() {
  yield takeEvery(constants.GET_BROWSE_ITEMS, getBrowseItems);
}

// eslint-disable-next-line import/prefer-default-export
export function* getBrowseItemsDebaunced(action) {
  const filters = yield select(getBrowseItemsFilters);

  const isLatestFiltersVersion = JSON.stringify(filters) === JSON.stringify(action.payload.filtersSnapshot);

  if(isLatestFiltersVersion) {
    yield put(setBrowseItemsFilters(action.payload.values));
    yield put(getBrowseItemsAction());
  }

  yield cancel();
}

export function* getBrowseItemsDebauncedWatcher() {
  yield debounce(2000, constants.GET_BROWSE_ITEMS_DELAYED, getBrowseItemsDebaunced);
}
